
export interface Alternatives{
  texto: string,
  letra: string
}

export interface Question{
  indice: number,
  texto: string,
  alternativas: Alternatives[]
  _id: string,
}

export interface Answer{
  list: string[],
  token: string
}


const JungClient = () => {

  return {
    async findAll(){
      const response =  await fetch('https://jung-self.herokuapp.com/jung/question', {
        method: 'GET',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
      });
      return await response.json();
    },

    async getProfile(result: string){
      const response =  await fetch(`https://jung-self.herokuapp.com/jung/profile/${result}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
      });
      return await response.json();
    },

    async calculateProfile(data: Answer){
      const response =  await fetch('https://jung-self.herokuapp.com/jung/result', {
        method: 'POST',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          'x-auth': data.token
        },
        body: JSON.stringify({answerArray: data.list})
      });
      return await response.json();
    },
  };
};

export default JungClient;
